import { DataTable, DataTableRowEditCompleteEvent, DataTableRowEditEvent} from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Column, ColumnEditorOptions} from "primereact/column";
import { InputText } from "primereact/inputtext";
import React from "react";
import { Button } from "primereact/button";
import UserDeleteDialog from "./edit-address-delete";
import { Toast, ToastMessage } from "primereact/toast";
import { Tag } from "primereact/tag";
import { CustomerAddressModel1, EditAddressModel1 } from "../../models/cust-address/cust-address-model";
import customerAddressService from "../../services/edit-address/cust-address.service";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { CityModel } from "../../models/city-model";
import { StateModel } from "../../models/state-model";
import UserAddressService from "../../services/useraddress/useraddress.service";
import { Dialog } from "primereact/dialog";
import GetAddressByLocation from "../user-address/location-search/get-location";
import RoleService from "../../services/role/role-service";

interface DataTableProps {
  data: CustomerAddressModel1[];
  filter: string;
  addAddressCallback: (uid : number) => void
  pageNumber: number;     // Add pageNumber prop
  pageSize: number;       // Add pageSize prop
  totalRecords: number;
  onPageChange: (event: { first: number, rows: number }) => void; // Function to handle page changes
  refreshTable: () => Promise<void>;
}


const EditAddressDataTable: React.FC<DataTableProps> = (props) => {
  const { t } = useTranslation();
  const toast = useRef<Toast>(null);
  const [userData, setUserData] = useState<CustomerAddressModel1[] | any>([]);
  const [selectedId, setSelectedId] = useState<number>(0);
  const [notifyHeader, setNotifyHeader] = useState("");
  const [notifyMessage, setNotifyMessage] = useState("");
  const [isNotifyVisible, setIsNotifyVisible] = useState(false);
  const [cities, setCities] = useState<CityModel[]>([]);
  const [states, setStates] = useState<StateModel[]>([]);
  const [isLocationMapVisible, setIsLocationMapVisible] = useState(false);
  const [latitude, setLatitude] = useState<number | null>(null);
  const [longitude, setLongitude] = useState<number | null>(null);

  const FetchStates = (countryId: number) => {
    UserAddressService.getStates(countryId).then(r =>  setStates(r));
  }

  const FetchCities = (stateId: number) => {
    UserAddressService.getCities(stateId).then(r =>  setCities(r));
  }

  const showMessage = (label: string, message: string, severity: ToastMessage['severity']) => {
    toast.current?.show({ severity: severity, summary: label, detail: message, life: 3000 });
  };

  useEffect(() => {
      setUserData(props.data);
  }, [props.data]);

  // useEffect(()=>{
  //   FetchStates(1);
  // },[]);
  const [areas, setAreas] = useState<{areaId: number; subDistrictId: number; areaName: string}[]>([]);
  const [subdistricts, setSubdistricts] = useState<{districtId: number; subDistrictId: number; subDistrictName: string}[]>([]);
  const [filterSubdistricts, setFilterSubdistricts] = useState<{districtId: number; subDistrictId: number; subDistrictName: string}[]>([]);
  const [districts, setDistricts] = useState<{districtId: number; districtName: string}[]>([]);
  const [pinstate, setPinState] = useState<{stateId: number; stateName: string;districtId:number}[]>([]);
  const [pincountry, setPinCountry] = useState<{countryId: number; countryName: string}[]>([]);
  const [selectedCountry, setSelectedCountry] = useState<string>("");
  const [filterDistricts, setFilterDistricts] = useState<{districtId: number; districtName: string}[]>([]);
  const[filterStates,setfilterStates] = useState<{stateId : number; districtId : number ; stateName : string}[]>([]);
const handleLocationFetch = async (pincode: number) => {
    try {
      setSubdistricts([]);
      setFilterSubdistricts([]);
      var responsedData = await UserAddressService.getAddress(pincode);
        if(responsedData != null && responsedData.isSuccess) {
          if (!responsedData.areas || responsedData.areas.length === 0) {
            showMessage("Error", "Area is not found please contact admin.", "error");
            return;
          }
        setAreas(responsedData.areas);
        setSubdistricts(responsedData.subDistricts);
        setFilterSubdistricts(responsedData.subDistricts);
        setDistricts(responsedData.districts);
        setFilterDistricts(responsedData.districts);
        setPinState(responsedData.states);
        setPinCountry(responsedData.countries);
        setfilterStates(responsedData.states);

        // if (responsedData.areas.length === 1) {
        // }
      }
      else {
        showMessage("Error" ,responsedData?.message || "Area is not found please contact admin", "error");
      }
    } catch (error) {
      showMessage("Error", "Failed to fetch pincode details", "error");
      return false;
    }
  };
  
  // Handle change of area selection
  const handelAreaChange = (Id: any, value: any, options: ColumnEditorOptions) => {
    const selectedArea = areas.find(x => x.areaId === value);
    const SubdistcId = selectedArea?.subDistrictId;
  
    // Filter subdistricts and districts based on selected area
    const filteredSubdistricts = filterSubdistricts.filter(x => x.subDistrictId === SubdistcId);
    const filteredDistricts = filterDistricts.filter(x => x.districtId === filteredSubdistricts[0]?.districtId);
    const filtersts = filterStates.filter(x => x.districtId === filteredDistricts[0].districtId);
  
    setDistricts(filteredDistricts);
    setSubdistricts(filteredSubdistricts);
    setPinState(filtersts);

    // Update newData with selected area
    options.rowData.areaId = selectedArea?.areaId;
    options.rowData.areaName = selectedArea?.areaName;
  
    // Also update the district and subDistrict
    const selectedDistrict = filteredDistricts[0];
    const selectedSubDistrict = filteredSubdistricts[0];
    const selectedState = pinstate[0];
  
    options.rowData.districtId = selectedDistrict?.districtId;
    options.rowData.districtName = selectedDistrict?.districtName;
    options.rowData.subDistrictId = selectedSubDistrict?.subDistrictId;
    options.rowData.subDistrictName = selectedSubDistrict?.subDistrictName;
    options.rowData.stateId = selectedState?.stateId;
    options.rowData.stateName = selectedState?.stateName;
  };

  const onRowEditInit = async (event: DataTableRowEditEvent) => {
    const pincode = event.data.zipcode;
    if (pincode && pincode.length === 6) {
      await handleLocationFetch(parseInt(pincode));
    }
  }

    const onRowEditComplete = async (event: DataTableRowEditCompleteEvent) => {
    let _data = [...userData];
    let { newData, index } = event;
   
    if(_data[index] !== newData) {      
      if(areas.length === 1){
        newData.areaId = areas[0].areaId;
        newData.areaName = areas[0].areaName;
        newData.districtId = districts[0].districtId;
        newData.districtName = districts[0].districtName;
        newData.subDistrictId = subdistricts[0].subDistrictId;
        newData.subDistrictName = subdistricts[0].subDistrictName;
        newData.stateId = pinstate[0].stateId;
        newData.stateName = pinstate[0].stateName
      }
 
      if(_data[index].areaId !== newData.areaId){
 
        let putData: EditAddressModel1 = {
          userAddressID: newData.userAddressID,
          userID: newData.userID,
          address1: newData.address1,
          address2: newData.address2,
          landmark: newData.landmark,
          countryID: newData.countryId,
          stateID:  newData.stateId,
          cityID: newData.cityID,
          areaId: newData.areaId!== "" && areas.length !== 1 ? newData.areaId : areas[0].areaId,
          zipcode: newData.zipcode
        };
        let response = await customerAddressService.updateAddress(putData);
        if(response.isSuccess) {
          showMessage('Update Address','User address updated successfully', 'success');
          _data[index] = newData as CustomerAddressModel1;
          setUserData(_data);
        }
        else
        {
          showMessage('Update Address', response.message + ': Error in update address', 'error');
        }
 
      }
      else{
        showMessage('Update Address','please update all the required fields', 'info');
      }
   
    }
  };

  const deleteUser = async () => {
    try {
      let response = await customerAddressService.deleteAddress(selectedId);
      if(response.isSuccess) {
        showMessage('Delete Address','Address deleted successfully', 'success');
        const updatedData = updateStatusOnDelete(selectedId);
        setUserData(updatedData);
      }
      else
      {
        showMessage('Delete User', response.message + ': Error in delete user', 'error');
      }
    }
    catch(error) {
      console.error(error);
    }       
  };

  function updateStatusOnDelete(id: number): CustomerAddressModel1[] {
    return userData.map((item: CustomerAddressModel1) => {
        if (item.userAddressID === id) {
            return { ...item, isDeleted: true };
        }
        return item;
    });
  }

  const handleAddAdminAddress = (uid: number) => {
    props.addAddressCallback(uid);
  }

const getCurrentLocation = (): Promise<{ latitude: number, longitude: number }> => {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const currLocation = {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude
            };
            resolve(currLocation);
          },
          (error) => {
            console.error("Error getting current location:", error.message);
            reject(error);
          }
        );
      } else {
        console.error("Geolocation is not supported by this browser.");
        reject(new Error("Geolocation is not supported by this browser."));
      }
    });
  };


  const openDirections = (rowData: CustomerAddressModel1) => {
  const gpsLocation = rowData?.gpsLocation;
  if (!gpsLocation || !gpsLocation.includes(",")) {
    showMessage('Invalid GPS', 'GPS location not available. Please update the GPS.', 'error');
    return;
  }

  const gpsData = gpsLocation.split(",");
  if (gpsData.length !== 2 || isNaN(+gpsData[0]) || isNaN(+gpsData[1])) {
    showMessage('Invalid GPS', 'GPS coordinates are invalid.', 'error');
    return;
  }

  getCurrentLocation()
    .then((currentLocation) => {
      const start = `${currentLocation.latitude},${currentLocation.longitude}`;
      const destination = `${gpsData[0]},${gpsData[1]}`;
      const url = `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(start)}&destination=${encodeURIComponent(destination)}`;
      window.open(url, '_blank');
    })
    .catch((error) => {
      console.error("Error:", error.message);
      showMessage('Invalid GPS', 'Please update the GPS', 'error');
    });
};
  
  

  const otherActionTemplate = (rowData: CustomerAddressModel1) => {
    return (
      <div className="flex">
        {RoleService.isAdmin() &&  <Button icon="pi pi-plus"
      onClick={()=>{handleAddAdminAddress(rowData.userID)}}
      style={{ border: 'none',color: 'gray', background: 'none' }}
      className="p-button-rounded p-mr-2"/>}
      <Button
        icon="pi pi-trash"
        onClick={() => onRowDelete(rowData)}
        style={{ border: 'none', color: 'gray', background: 'none'}}
        className="p-button-rounded"
      />
      <Button
        icon="pi pi-map-marker"
        onClick={() => {setIsLocationMapVisible(true); setSelectedId(rowData.userAddressID)}}
        style={{ border: 'none', color: 'gray', background: 'none'}}
        className="p-button-rounded ml-1"
      />  
      <Button
        icon="pi pi-arrow-circle-right"
        onClick={() => {openDirections(rowData)}}
        style={{ border: 'none', color: 'gray', background: 'none'}}
        className="p-button-rounded ml-1"
      />  
      </div>
    )
  }

  const onRowDelete = (rowData: CustomerAddressModel1) => {
      setSelectedId(rowData.userAddressID);
      setNotifyHeader("Delete Address");
      setNotifyMessage("Are you sure you want to delete this address?");
      setIsNotifyVisible(true); 
  };

  const hideNotifyDialog = (value: boolean) => {
    if (value) {
      deleteUser();      
    }
    setIsNotifyVisible(false);
  };
  const statusBodyTemplate = (rowData: CustomerAddressModel1) => {
    return <Tag value={rowData.isDeleted ? "Deleted" : "Active"} severity={getSeverity(rowData.isDeleted)}></Tag>;
  };

  const getSeverity = (value: boolean) => {
    switch (value) {
        case true:
            return 'danger';

        case false:
            return 'info';

        default:
            return null;
    }
  };

  const textEditor = (options: ColumnEditorOptions) => {
    return <InputText type="text" value={options.value} style={{ width: '95%', border:'1px solid #090' }}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => options.editorCallback!(e.target.value)} />;
  };   

  // const stateEditor = (options: ColumnEditorOptions) => {
  //   let editOptionVal = typeof options.value === 'string' ? options.rowData.stateID : options.value;
  //   return (<Dropdown className='border-1 border-primary' value={editOptionVal} options={states} optionLabel="name" optionValue="stateID"
  //     style={{ width: '95%' }} onChange={(e: DropdownChangeEvent) => {options.editorCallback!(e.value); FetchCities(e.value)}} />);
  // };

  const cityEditor = (options: ColumnEditorOptions) => {
    let editOptionVal = typeof options.value === 'string' ? options.rowData.cityID : options.value;
    return (<Dropdown className='border-1 border-primary' value={editOptionVal} options={cities} optionLabel="name" optionValue="cityID"
      style={{ width: '95%' }} onChange={(e: DropdownChangeEvent) => options.editorCallback!(e.value)} />);
  };
  
  const zipcodeEditor = (options: ColumnEditorOptions) => {
    const value = options.value || '';
   
    const handlePincodeChange = async (newValue: string) => {
      options.editorCallback!(newValue);
     
      if (newValue.length === 6) {
        const numericPincode = parseInt(newValue);
        if (!isNaN(numericPincode)) {
          await handleLocationFetch(numericPincode);
        }
      }
    };
 
    return (
      <div className="field col-12 md:col-8">
        <div className="p-inputgroup">
          <span className="p-input-icon-left">
            <i className="pi pi-hashtag" />
            <InputText
              keyfilter="int"
              name="zipcode"
              value={value}
              placeholder="Please enter pincode"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => handlePincodeChange(e.target.value)}
              style={{ width: '100px' }}
              onKeyPress={(e) => {
                if (!/[0-9]/.test(e.key)) {
                  e.preventDefault();
                }
              }}
              maxLength={6}
            />
          </span>
          <Button
            icon="pi pi-search"
            severity="success"
            aria-label="Search"
            style={{ width: '100px' }}
            onClick={() => {
              if (value.length >3) {
                handleLocationFetch(parseInt(value));
              }
            }}
          />
        </div>
      </div>
    );
  };
  
  const areaEditor = (options: ColumnEditorOptions) => {
    const value = options.value || '';
  
    return (
      <Dropdown
        value={areas.length === 1 ? areas[0].areaId : value}
        options={areas.map((area: any) => ({
          label: area.areaName,
          value: area.areaId,
        }))}
        onChange={(e) => {
          const selectedAreaId = e.value;
          options.editorCallback!(selectedAreaId); 
          const selectedArea = areas.find(area => area.areaId === selectedAreaId);
          if (selectedArea) {
            options.rowData.areaId = selectedArea.areaId;
            options.rowData.areaName = selectedArea.areaName;
          }
          handelAreaChange("areaId", selectedAreaId, options); 
        }}
        placeholder="Select Area"
        disabled={areas.length === 1}
        style={{ width: '95%' }}
      />
    );
  };
  
  const subDistrictEditor = (options: ColumnEditorOptions) => {
    const value = options.value || '';
  
    return (
      <Dropdown
        value={subdistricts.length === 1 ? subdistricts[0].subDistrictId : value}
        options={subdistricts.map((subdistrict: any) => ({
          label: subdistrict.subDistrictName,
          value: subdistrict.subDistrictId,
        }))}
        onChange={(e) => {
          const selectedSubDistrictId = e.value;
          options.editorCallback!(selectedSubDistrictId); 
          const selectedSubDistrict = subdistricts.find(subdistrict => subdistrict.subDistrictId === selectedSubDistrictId);
          if (selectedSubDistrict) {
            options.rowData.subDistrictId = selectedSubDistrict.subDistrictId;
            options.rowData.subDistrictName = selectedSubDistrict.subDistrictName;
          }
        }}
        placeholder="Select SubDistrict"
       disabled={true}
        style={{ width: '95%' }}
      />
    );
  };
  
  const districtEditor = (options: ColumnEditorOptions) => {
    const value = options.value || '';
  
    return (
      <InputText
        value={districts.length === 1 ? districts[0].districtName : value}
        onChange={(e) => {
          const selectedDistrictName = e.target.value;
          options.editorCallback!(selectedDistrictName); 
          const selectedDistrict = districts.find(district => district.districtName === selectedDistrictName);
          if (selectedDistrict) {
            options.rowData.districtId = selectedDistrict.districtId;
            options.rowData.districtName = selectedDistrict.districtName;
          }
        }}
        disabled={true}
        style={{ width: '95%' }}
      />
    );
  };
  
  // Editor for State Field
const stateEditor = (options: ColumnEditorOptions) => {
  const value = options.value || '';

  return (
    <InputText
      value={pinstate.length === 1 ? pinstate[0].stateName : value}
      onChange={(e) => {
        const selectedStateName = e.target.value;
        options.editorCallback!(selectedStateName); // Update the value in the editor callback
        const selectedState = pinstate.find(state => state.stateName === selectedStateName);
        if (selectedState) {
          // Update newData with stateId and stateName
          options.rowData.stateId = selectedState.stateId;
          options.rowData.stateName = selectedState.stateName;
        }
      }}
      disabled={true}
      style={{ width: '95%' }}
    />
  );
};
  
  // Editor for Country Field
  const countryEditor = (options: ColumnEditorOptions) => {
    const value = options.value || '';
  
    return (
      <InputText
        value={pincountry.length === 1 ? pincountry[0].countryName : value}
        onChange={(e) => {
          const selectedCountryName = e.target.value;
          options.editorCallback!(selectedCountryName); // Update the value in the editor callback
          const selectedCountry = pincountry.find(country => country.countryName === selectedCountryName);
          if (selectedCountry) {
            // Update newData with countryId and countryName
            options.rowData.countryId = selectedCountry.countryId;
            options.rowData.countryName = selectedCountry.countryName;
          }
        }}
        disabled={true}
        style={{ width: '95%' }}
      />
    );
  };

  const updateLatitudeAndLongitude = (location: string) => {
    if (location) {
      try {
        var locationSplit = location.split(",");
        setLatitude(parseFloat(locationSplit[0]));
        setLongitude(parseFloat(locationSplit[1]));
      } catch {
      }
    }
  }

  const updateGpsLocation = async (latLng: any) => {
    setIsLocationMapVisible(false);
    updateLatitudeAndLongitude(latLng);
    if(latLng && selectedId != null){
      const response=await UserAddressService.updateGPSLocation(selectedId, latLng);
     if (response && response.isSuccess) {
        toast.current?.show({
          severity: 'success',
          summary: 'Success',
          detail: 'GPS location updated successfully.',
          life: 3000,
        });

        props.refreshTable(); 
      } else {
        toast.current?.show({
          severity: 'error',
          summary: 'Error',
          detail: response?.message || 'Failed to update GPS location.',
          life: 3000,
        });
      }
    }    
  }  

  return (
    <>
    <Toast ref={toast} position="top-center" />  
    <div className="col-12">
        <div className="card border-noround p-2">                
    <DataTable
            value={userData}  
            paginator
            rows={props.pageSize}  
            rowsPerPageOptions={[5, 10, 25, 50, 100]}
            totalRecords={props.totalRecords}
            lazy={true}
            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
            currentPageReportTemplate={`{first} to {last} of ` + props.totalRecords}
            first={(props.pageNumber - 1) * props.pageSize}
    
            onPage={props.onPageChange}
            globalFilter={props.filter || " "}  
            editMode="row"
            onRowEditInit={onRowEditInit}
            onRowEditComplete={onRowEditComplete}
          >
                <Column field="userName" header="User Name" style={{ width: '9%' }}/>
                <Column field="primaryContactNbr" header="Mobile #" style={{ width: '8%' }}/>
                <Column field="address1" header="Address line1" editor={textEditor} style={{ width: '12%' }}/>
                <Column field="address2" header="Address line2" editor={textEditor} style={{ width: '12%' }}/>
                <Column field="landmark" header="Landmark" editor={textEditor} style={{ width: '12%' }}/>
                <Column field="areaName" header="Area" editor={areaEditor} style={{ width: '12%' }}/>
                <Column field="subDistrictName" header="SubDistrict" editor={subDistrictEditor} style={{ width: '12%' }}/>
                <Column field="districtName" header="District" editor={districtEditor} style={{ width: '12%' }}/>
                <Column field="countryName" header="Country" editor={countryEditor} style={{ width: '12%' }}/>
                <Column field="stateName" header="State" editor={stateEditor} style={{ width: '12%' }}/>
                <Column field="zipcode" header="Pincode" editor={zipcodeEditor} style={{ width: '10%' }}/>
                <Column field="isDeleted" header="Status" body={statusBodyTemplate} style={{ width: '6%' }}/>
                <Column rowEditor header={t('assignRouteCode_action')} headerStyle={{ textAlign: 'right' }}/>                  
                <Column body={(options) => otherActionTemplate(options)}/>
            </DataTable>            
        </div>
        <UserDeleteDialog
          messageHeader={notifyHeader}
          notifyMessage={notifyMessage}
          isVisible={isNotifyVisible}
          isHide={hideNotifyDialog}
        />        
    </div>
    <Dialog
      header="Search your location"
      className='location-dialog'
      visible={isLocationMapVisible}
      onHide={() => setIsLocationMapVisible(false)}
      footer={""}
      style={{ width: "50%" }}
    >
      <GetAddressByLocation getLatitudeLongitude={updateGpsLocation} lat={latitude} lng={longitude}></GetAddressByLocation>
    </Dialog> 
    </>
  )
};
export default EditAddressDataTable;
